// extracted by mini-css-extract-plugin
export default {"publishing-buttons":"PagePublishingButtons_publishing-buttons__O41Lu","publishingButtons":"PagePublishingButtons_publishing-buttons__O41Lu"};